import { render } from "./FundInfo.vue?vue&type=template&id=00ff2eda"
import script from "./FundInfo.vue?vue&type=script&lang=js"
export * from "./FundInfo.vue?vue&type=script&lang=js"

import "./FundInfo.vue?vue&type=style&index=0&id=00ff2eda&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__